import { API_AUTH, ApiClientService } from '@dfl/react-security';
import { getDeviceId } from 'modules/notification/services/device-id.service';

export const logoutCurrentSession = async (): Promise<void> => {
  const refreshToken = ApiClientService.getRefreshToken();
  if (!refreshToken) return;

  await ApiClientService.post(`${API_AUTH.url}/logout`, {
    refreshToken,
    deviceId: getDeviceId(),
  });
};

let refreshPromise: Promise<unknown> | null = null;

export const refreshCurrentSession = (): Promise<unknown> => {
  if (refreshPromise) return refreshPromise;

  refreshPromise = ApiClientService.post(
    `${API_AUTH.url}/refresh-token`,
    {
      token: ApiClientService.getToken(),
      refresh: ApiClientService.getRefreshToken(),
      space: ApiClientService.getSpace(),
      deviceId: getDeviceId(),
    },
    { ignoreToken: true }
  )
    .then((response) => {
      ApiClientService.setAuthData(response.data);
      return response;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};
